import React from "react";
import { useAuth0, withAuthenticationRequired, User } from "@auth0/auth0-react";
import Loading from "./Loading";
import Skeleton from "./Skeleton";
import { useStorageMap } from "../storage/Storage";
import { classNames } from "../utils";
import ReactTooltip from "react-tooltip";

type Props = {
  fullDisplay?: boolean;
  showSupport?: boolean;
};

const buildProfileLabel = (user: User): string => {
  const labelFromNames =
    user.given_name ??
    user.family_name ??
    user.preferred_username ??
    user.name ??
    " ";
  return labelFromNames;
};

const ProfileComponent = ({
  fullDisplay = true,
  showSupport = true,
}: Props) => {
  const { user, logout } = useAuth0();
  const { clearLocalStorageCachedValues } = useStorageMap();
  function appLogout() {
    clearLocalStorageCachedValues();
    logout({ returnTo: window.location.origin });
  }

  if (!user) return <Loading />;
  return (
    <div className="p-2">
      <div
        data-tip="Sign out"
        data-for="sign-out-tooltip"
        className={classNames(
          `flex`,
          fullDisplay ? "flex-row" : "flex-col items-center"
        )}
      >
        <img
          src={user.picture}
          alt="Profile"
          className="shadow-xl rounded-full border-1 w-10 h-10 row-span-3 cursor-pointer"
          referrerPolicy="no-referrer"
          onClick={appLogout}
        />
        <div className="flex flex-col">
          {fullDisplay && (
            <div
              className="flex flex-col justify-center items-left px-2 cursor-pointer"
              onClick={appLogout}
            >
              <span className="row-span-1 col-span-2 text-xs flex justify-center items-center text-gray-700">
                {buildProfileLabel(user)}
              </span>
              <div className="row-span-1 col-span-2 justify-self-left text-xs text-gray-500 border-b pb-3">
                <span className="cursor-pointer ">Sign Out</span>
              </div>
            </div>
          )}

          {showSupport && (
            <a
              className="px-2 mt-1 text-xs justify-end block text-gray-500 cursor-pointer"
              rel="noreferrer"
              target="_blank"
              href="https://support.fama.io/hc/en-us"
            >
              Support
            </a>
          )}
        </div>
      </div>
      {!fullDisplay && (
        <ReactTooltip
          className="hover:visible:opacity-1 w-36"
          effect="solid"
          id="sign-out-tooltip"
        />
      )}
    </div>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Skeleton />,
});
